import _ from "lodash";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

export default function BasicTable({ columns, rows = [], onRowClick, ...props }) {
    const hover = onRowClick !== undefined;

    function handleHowClick(row, rowIndex) {
        if (onRowClick) {
            onRowClick(row, rowIndex);
        }
    }

    return (
        <TableContainer {...props}>
            <Table>
                <TableHead>
                    {/* TODO: col.flex */}
                    <TableRow>
                        {columns.map((col) => (
                            <TableCell key={col.headerName} align={col.align} sx={{ flex: col.flex }}>
                                {col.headerName}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {rows.map((row, rowId) => (
                        <TableRow
                            key={rowId}
                            sx={
                                hover
                                    ? {
                                        "&:hover": {
                                            cursor: "pointer",
                                        },
                                    }
                                    : null
                            }
                            hover={hover}
                            onClick={() => handleHowClick(row, rowId)}
                        >
                            {columns.map((col, colId) => (
                                <TableCell key={colId} align={col.align}>
                                    {col.valueGetter ? col.valueGetter(row) : _.get(row, col.field)}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
